(function () {
  // VK_MENU_REORG_FIX: move "Streetwear Belts" from the Belts nav group to the
  // Accessories nav group. Display-only DOM move — does not touch the Shopify
  // navigation menu data, so this only affects this theme.
  function moveDesktopItem(hrefSuffix, destTriggerId) {
    var link = document.querySelector('.navbar-dropdown a[href$="' + hrefSuffix + '"]');
    if (!link) return;
    var moveEl = link.closest('.horizontal-dropdown__column') || link;
    var trigger = document.getElementById(destTriggerId);
    var dest = trigger && trigger.nextElementSibling;
    if (dest && dest.classList.contains('navbar-dropdown')) {
      dest.appendChild(moveEl);
    }
  }

  function moveMobileItem(hrefSuffix, destHrefSuffix) {
    var mobileMenu = document.querySelector('.mobile-menu');
    if (!mobileMenu) return;
    var link = mobileMenu.querySelector('a[href$="' + hrefSuffix + '"]');
    if (!link) return;
    var moveEl = link.closest('.mobile-menu__submenu-list-item') || link.closest('li');
    if (!moveEl) return;
    var destTrigger = mobileMenu.querySelector('a[href$="' + destHrefSuffix + '"]');
    var destBlock = destTrigger && destTrigger.closest('.mobile-menu__first-level');
    var destList = destBlock && destBlock.querySelector('ul.mobile-submenu__list');
    if (destList) {
      destList.appendChild(moveEl);
    }
  }

  function moveMegaMenuItem(hrefSuffix, destHrefSuffix) {
    var link = document.querySelector('.mega-menu__linklist a[href$="' + hrefSuffix + '"]');
    if (!link) return;
    var moveEl = link.closest('li');
    if (!moveEl) return;
    var srcBlock = link.closest('.mega-menu__linklist');
    var destTrigger = document.querySelector('.mega-menu__linklist a[href$="' + destHrefSuffix + '"]');
    var destBlock = destTrigger && destTrigger.closest('.mega-menu__linklist');
    if (!destBlock || destBlock === srcBlock) return;
    var destList = destBlock.querySelector('ul');
    if (destList) {
      destList.appendChild(moveEl);
    }
  }

  function vkReorgMenu() {
    moveDesktopItem('/collections/streetwear-belts', 'dropdown-accessories');
    moveMobileItem('/collections/streetwear-belts', '/collections/accessories');
    moveMegaMenuItem('/collections/streetwear-belts', '/collections/accessories');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vkReorgMenu);
  } else {
    vkReorgMenu();
  }
})();
